
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CreditCard } from 'lucide-react';

interface AppointmentStatusBadgesProps {
  status: string;
  paymentStatus?: string | null;
  refundStatus?: string | null;
  hasBeenReviewed?: boolean;
}

export const AppointmentStatusBadges: React.FC<AppointmentStatusBadgesProps> = ({ 
  status,
  paymentStatus,
  refundStatus,
  hasBeenReviewed 
}) => {
  const getStatusBadgeVariant = (status: string) => {
    switch(status) {
      case 'Completed':
        return 'bg-green-50 text-green-600 border-green-200';
      case 'Cancelled':
        return 'bg-red-50 text-red-600 border-red-200';
      case 'Cancellation Requested':
        return 'bg-orange-50 text-orange-600 border-orange-200';
      case 'No Show':
        return 'bg-gray-50 text-gray-600 border-gray-200';
      case 'Pending Payment':
        return 'bg-yellow-50 text-yellow-600 border-yellow-200';
      default:
        return 'bg-blue-50 text-blue-600 border-blue-200';
    }
  };

  const getPaymentStatusBadge = (status: string | null | undefined) => {
    if (!status) return null;
    
    let badgeClass = '';
    switch(status) {
      case 'Paid':
        badgeClass = 'bg-green-50 text-green-600 border-green-200';
        break;
      case 'Pending':
      case 'Awaiting Payment':
        badgeClass = 'bg-yellow-50 text-yellow-600 border-yellow-200';
        break;
      case 'Failed':
        badgeClass = 'bg-red-50 text-red-600 border-red-200';
        break;
      default:
        badgeClass = 'bg-gray-50 text-gray-600 border-gray-200';
    }
    
    return (
      <Badge variant="outline" className={badgeClass}>
        <CreditCard className="h-3 w-3 mr-1" />
        {status}
      </Badge>
    );
  };

  return (
    <div className="space-y-1">
      <Badge 
        variant="outline" 
        className={getStatusBadgeVariant(status)}
      >
        {status}
      </Badge>
      
      {paymentStatus && (
        getPaymentStatusBadge(paymentStatus)
      )}
      
      {refundStatus === 'pending_user_approval' && (
        <Badge 
          variant="outline" 
          className="bg-blue-50 text-blue-600 border-blue-200"
        >
          Refund Requested
        </Badge>
      )}
      
      {hasBeenReviewed && (
        <Badge 
          variant="outline" 
          className="bg-amber-50 text-amber-600 border-amber-200"
        >
          Reviewed
        </Badge>
      )}
    </div>
  );
};
